module.exports = __webpack_public_path__ + "static/logo-main-white-bab78764714dac04072b6a1e4367c250.png";